<div
  class="fgbcl-game-answer-type-image-and-text-section"
  [ngClass]="{ 'fgbcl-predictor': groupType == groupTypes.Predictor, 'fgbcl-trivia': groupType == groupTypes.Trivia }"
>
  <div
    *ngFor="let answer of answers"
    (click)="onAnswerSelected(answer)"
    class="fgbcl-game-answer-type-image-and-text-container"
    [ngClass]="{
      'fgbcl-game-selected-correct-answer': groupType == groupTypes.Trivia && answer.UserSelected && answer.IsCorrect && !loading,
      'fgbcl-game-selected-incorrect-answer':
        groupType == groupTypes.Trivia && answer.UserSelected && !answer.IsCorrect && !loading,
      'fgbcl-game-correct-answer': groupType == groupTypes.Trivia && answer.IsCorrect && !answer.UserSelected,
      'fgbcl-game-no-selected-answer-overlay':
        selectedAnswer &&
        ((groupType == groupTypes.Trivia && !answer.UserSelected && !answer.IsCorrect) ||
          (groupType === groupTypes.Predictor && selectedAnswer.Id !== answer.Id)),
      'fgbcl-game-selected-answer': groupType === groupTypes.Predictor && selectedAnswer && selectedAnswer.Id == answer.Id,
    }"
  >
    <div class="fgbcl-game-answer-image-section">
      <img class="fgbcl-game-answer-image" [src]="answer.ImageUrl | contentImage: '7'" alt="{{ answer.Title }}" />
      <span *ngIf="groupType == groupTypes.Trivia && answer.IsCorrect && !loading" class="fgbcl-game-answer-status-text">
        {{ 'fgbcl.game.correct.answer.text' | translate }}
      </span>
      <span
        *ngIf="groupType == groupTypes.Trivia && answer.UserSelected && !answer.IsCorrect && !loading"
        class="fgbcl-game-answer-status-text"
      >
        {{ 'fgbcl.game.incorrect.answer.text' | translate }}
      </span>
      <span
        *ngIf="groupType === groupTypes.Predictor && selectedAnswer && selectedAnswer.Id == answer.Id"
        class="fgbcl-game-answer-status-text"
      >
        {{ 'fgbcl.game.predictor.selected.text' | translate }}
      </span>
    </div>
    <div class="fgbcl-game-answer-text">{{ answer.Title }}</div>
  </div>
</div>
